__turbopack_context__.v({
  "course-languages": "course-language-module-scss-module__OQCKeq__course-languages",
});
